// extracted by mini-css-extract-plugin
export default {"selected-account":"K3AZUG","information":"cNJLT4","selected-account_faded":"lq3Tna"};